import { Container } from "@mui/material";

export default function RefundPolicy() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: { xs: "80vh", sm: "80vh", md: "81.2vh" },
        marginTop: "10px",
        // marginBottom: "10px",
        paddingBottom: "10px",
        // display: "flex",
        // alignItems: "center",
        // justifyContent: "center",
      }}
    >
      <h1>Return/Refund Policy</h1>
      <p>Last updated: June 09, 2022</p>
      <h1>REFUNDS</h1>
      <h2>Interpretation</h2>
      <p>All sales are final. No refunds will be given for any reason.</p>
      <h2>Questions</h2>
      <p>
        If you have any question concerning our return policy, please contact us
        at
      </p>
      <ul>
        <li>
          <p>
            <strong>Phone: </strong> +918848668847
          </p>
        </li>
        <li>
          <p>
            <strong>Email: </strong> robvationclub@gmail.com
          </p>
        </li>
      </ul>
    </Container>
  );
}
